import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy',
  standalone: true,
  template: `
    <main class="max-w-3xl mx-auto px-8 py-32">

      <header class="mb-16">
        <span class="font-sans font-bold text-sm text-gold-accent mb-4 block tracking-widest uppercase">Legal</span>
        <h1 class="font-serif text-5xl text-on-surface mb-6">Privacy Policy</h1>
        <div class="w-24 h-1 bg-gold-accent mb-8"></div>
        <p class="font-sans text-on-surface-variant">
          At Regency House Cleaning, we value your privacy and are committed to protecting your personal
          information. This Privacy Policy explains how we collect, use, and safeguard the information
          you provide when using our website or booking our services.
        </p>
      </header>

      <div class="space-y-12 font-sans text-on-surface-variant">

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Information We Collect</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p class="mb-4">We may collect information you voluntarily provide, including:</p>
          <ul class="space-y-2 pl-4">
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Name
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Email address
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Phone number
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Home address
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Service preferences
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Appointment details
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Payment information (processed securely through third-party payment providers)
            </li>
          </ul>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">How We Use Your Information</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p class="mb-4">Your information is used to:</p>
          <ul class="space-y-2 pl-4">
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Schedule and manage cleaning appointments
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Communicate regarding your bookings and services
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Respond to questions and customer support requests
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Improve our services and customer experience
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-gold-accent text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">circle</span>
              Send appointment reminders and service updates
            </li>
          </ul>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Information Sharing</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            We do not sell, rent, or trade your personal information. Information is shared only when
            necessary to process payments, operate our business, or comply with legal obligations.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Data Security</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            We implement reasonable administrative, technical, and physical safeguards to protect your
            personal information from unauthorized access, disclosure, or misuse.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Cookies</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            Our website may use cookies and similar technologies to improve functionality, analyze website
            traffic, and enhance your browsing experience. You can manage cookie preferences through your
            browser settings.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Third-Party Services</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            Our website may contain links to third-party websites or use third-party services for
            scheduling, payment processing, or analytics. These providers maintain their own privacy
            policies.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Your Rights</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            You may request access to, correction of, or deletion of your personal information by
            contacting us. We will respond in accordance with applicable laws.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Changes to This Policy</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            We may update this Privacy Policy periodically. Any changes will be posted on this page
            with the updated effective date.
          </p>
        </section>

        <section>
          <h2 class="font-serif text-2xl text-on-surface mb-4">Contact Us</h2>
          <div class="w-12 h-0.5 bg-gold-accent mb-6"></div>
          <p>
            If you have questions about this Privacy Policy or how your information is handled, please
            contact us through our website or by email at
            <a href="mailto:info@regencyhousecleaning.com" class="text-gold-accent hover:underline">
              info&#64;regencyhousecleaning.com
            </a>.
          </p>
        </section>

      </div>
    </main>
  `,
})
export class PrivacyComponent {}
